export const carouselItems = [
  {
    id: 1,
    tag: '独家爆料',
    title: '某顶流男星深夜密会神秘女子，酒店共度8小时引热议',
    summary: '据知情人透露，该男星近期行程异常，粉丝后援会已紧急发声。事件持续发酵中，多方回应说法不一。',
    image: 'https://readdy.ai/api/search-image?query=Paparazzi%20style%20night%20scene%20with%20blurred%20celebrity%20figure%20entering%20luxury%20hotel%20entrance%2C%20dramatic%20lighting%2C%20news%20photography%20aesthetic%2C%20warm%20amber%20street%20lights%2C%20cinematic%20mood%2C%20entertainment%20news%20atmosphere&width=800&height=500&seq=carousel-01&orientation=landscape',
    heat: '98.7万',
    time: '2小时前',
  },
  {
    id: 2,
    tag: '网红翻车',
    title: '千万粉丝女主播直播间意外走光，品牌方紧急终止合作',
    summary: '直播事故发生后，多个品牌连夜删除合作内容，该主播已关闭评论区。业内人士称违约金或超千万。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20streaming%20studio%20setup%20with%20ring%20light%20and%20empty%20chair%2C%20dark%20moody%20atmosphere%2C%20broadcast%20equipment%20with%20cables%2C%20contrasting%20warm%20and%20cold%20lighting%2C%20news%20drama%20aesthetic&width=800&height=500&seq=carousel-02&orientation=landscape',
    heat: '156.3万',
    time: '5小时前',
  },
  {
    id: 3,
    tag: '明星塌房',
    title: '知名女星税务问题再升级，工作室被查封涉案金额惊人',
    summary: '继上次补税风波后，该艺人再次被曝税务违规。相关部门已介入调查，多个待播作品面临下架风险。',
    image: 'https://readdy.ai/api/search-image?query=Sealed%20office%20building%20with%20official%20notice%20paper%20on%20door%2C%20dramatic%20shadows%2C%20urban%20night%20scene%2C%20news%20investigation%20atmosphere%2C%20warm%20street%20lights%20reflecting%20on%20glass%20windows&width=800&height=500&seq=carousel-03&orientation=landscape',
    heat: '203.5万',
    time: '8小时前',
  },
  {
    id: 4,
    tag: '娱乐圈大瓜',
    title: '综艺节目录制现场爆发冲突，两位嘉宾当场翻脸罢录',
    summary: '现场观众爆料冲突起因疑似剧本分配不公，节目组已紧急删减相关画面。网友扒出两人早有恩怨。',
    image: 'https://readdy.ai/api/search-image?query=Empty%20TV%20studio%20set%20with%20overturned%20chairs%20and%20scattered%20papers%2C%20dramatic%20stage%20lighting%2C%20reality%20show%20atmosphere%2C%20behind%20scenes%20chaos%2C%20warm%20spotlight%20contrast&width=800&height=500&seq=carousel-04&orientation=landscape',
    heat: '89.2万',
    time: '3小时前',
  },
  {
    id: 5,
    tag: '恋情曝光',
    title: '当红小生与圈外女友甜蜜同游被拍，粉丝集体破防脱粉',
    summary: '两人牵手逛街画面曝光后，该艺人社交账号一夜掉粉超50万。工作室至今未作任何回应。',
    image: 'https://readdy.ai/api/search-image?query=Couple%20walking%20hand%20in%20hand%20on%20busy%20shopping%20street%20at%20sunset%2C%20blurred%20background%20with%20city%20lights%2C%20paparazzi%20long%20shot%20style%2C%20warm%20golden%20hour%20lighting%2C%20romantic%20yet%20dramatic%20mood&width=800&height=500&seq=carousel-05&orientation=landscape',
    heat: '178.6万',
    time: '6小时前',
  },
  {
    id: 6,
    tag: '深度扒皮',
    title: '某带货主播被曝售假，消费者维权群已超万人集体诉讼',
    summary: '第三方检测报告显示多款产品成分与宣传严重不符。平台已下架相关商品，律师团队已介入。',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20product%20authentication%20scene%20with%20magnifying%20glass%20and%20certificates%20on%20dark%20wooden%20desk%2C%20dramatic%20investigation%20atmosphere%2C%20warm%20desk%20lamp%20lighting%2C%20forensic%20analysis%20aesthetic&width=800&height=500&seq=carousel-06&orientation=landscape',
    heat: '134.8万',
    time: '4小时前',
  },
];

export const topicItems = [
  { id: 1, name: '某顶流恋情', heat: '2035万', trend: 'up', isHot: true },
  { id: 2, name: '直播事故合集', heat: '1892万', trend: 'up', isHot: true },
  { id: 3, name: '明星税务风波', heat: '1654万', trend: 'up', isHot: true },
  { id: 4, name: '综艺冲突现场', heat: '1421万', trend: 'up', isHot: false },
  { id: 5, name: '带货翻车汇总', heat: '1287万', trend: 'up', isHot: false },
  { id: 6, name: '网红人设崩塌', heat: '1156万', trend: 'stable', isHot: false },
  { id: 7, name: '娱乐圈潜规则', heat: '1023万', trend: 'up', isHot: false },
  { id: 8, name: '明星离婚内幕', heat: '987万', trend: 'stable', isHot: false },
  { id: 9, name: '选秀节目黑幕', heat: '856万', trend: 'down', isHot: false },
];

export const cardItems = [
  {
    id: 1,
    tag: '深度揭秘',
    title: '某短视频平台头部网红背后的资本运作：揭秘MCN机构如何批量制造顶流',
    excerpt: '从素人到千万粉丝仅用三个月，背后是精心策划的人设包装和流量投放。本文深度还原网红孵化产业链的完整运作模式...',
    image: 'https://readdy.ai/api/search-image?query=Modern%20social%20media%20analytics%20dashboard%20with%20charts%20and%20data%20visualization%20on%20multiple%20screens%2C%20dark%20office%20setting%20with%20neon%20accents%2C%20tech%20startup%20atmosphere%2C%20warm%20screen%20glow%20on%20faces&width=800&height=500&seq=card-01&orientation=landscape',
    time: '2026-07-30',
    views: '45.8万',
    comments: '3.2万',
  },
  {
    id: 2,
    tag: '热门追踪',
    title: '某女星离婚案庭审细节曝光：财产分割涉及数十亿，抚养权争夺白热化',
    excerpt: '法庭内部人士透露，双方律师团队已交锋多轮。涉及的房产、公司股权和品牌代言成为争议焦点...',
    image: 'https://readdy.ai/api/search-image?query=Courthouse%20exterior%20with%20dramatic%20sky%20and%20long%20shadows%2C%20grand%20architecture%2C%20formal%20atmosphere%2C%20news%20media%20vans%20parked%20outside%2C%20warm%20afternoon%20light%2C%20legal%20drama%20aesthetic&width=800&height=500&seq=card-02&orientation=landscape',
    time: '2026-07-29',
    views: '67.3万',
    comments: '5.8万',
  },
  {
    id: 3,
    tag: '独家调查',
    title: '娱乐圈饭圈乱象调查：集资打榜背后隐藏的灰色产业链全曝光',
    excerpt: '本报记者历时三个月卧底多个粉丝群，揭示了从集资、刷数据到恶意引战的完整操作链条...',
    image: 'https://readdy.ai/api/search-image?query=Anonymous%20figure%20typing%20on%20laptop%20in%20dark%20room%20with%20multiple%20phone%20screens%20showing%20social%20media%20feeds%2C%20investigative%20journalism%20mood%2C%20warm%20screen%20light%2C%20cyber%20detective%20aesthetic&width=800&height=500&seq=card-03&orientation=landscape',
    time: '2026-07-28',
    views: '89.1万',
    comments: '7.5万',
  },
  {
    id: 4,
    tag: '内幕曝光',
    title: '知名综艺导演被曝职场霸凌，多位艺人匿名发声控诉录制期间遭遇',
    excerpt: '多名曾参与该导演节目的艺人通过第三方渠道讲述了录制期间的种种不愉快经历，引发行业震动...',
    image: 'https://readdy.ai/api/search-image?query=Film%20set%20with%20director%20chair%20and%20professional%20camera%20equipment%2C%20empty%20studio%20with%20dramatic%20lighting%2C%20behind%20scenes%20atmosphere%2C%20warm%20spotlights%20creating%20long%20shadows&width=800&height=500&seq=card-04&orientation=landscape',
    time: '2026-07-27',
    views: '56.4万',
    comments: '4.1万',
  },
  {
    id: 5,
    tag: '实时更新',
    title: '某男团成员被扒恋爱史：同时交往多位女粉丝，聊天记录全泄露',
    excerpt: '大量私密聊天截图在社交平台疯传，涉及多位女粉丝。经纪公司紧急发布声明称将通过法律途径维权...',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20chat%20messages%20with%20dramatic%20red%20lighting%2C%20dark%20surroundings%2C%20privacy%20breach%20concept%2C%20social%20media%20scandal%20mood%2C%20warm%20phone%20glow%20in%20darkness&width=800&height=500&seq=card-05&orientation=landscape',
    time: '2026-07-30',
    views: '123.6万',
    comments: '9.8万',
  },
];

export const commentItems = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=Stylish%20young%20Asian%20woman%20portrait%20with%20trendy%20makeup%2C%20studio%20lighting%2C%20warm%20skin%20tones%2C%20professional%20headshot%20style%2C%20clean%20neutral%20background&width=120&height=120&seq=avatar-01&orientation=squarish',
    nickname: '吃瓜一线战士',
    time: '30分钟前',
    content: '我就说这个圈子水很深吧！之前那个综艺我就觉得不对劲，导演对女嘉宾的态度明显有问题。终于有人站出来了，支持勇敢发声的艺人！',
    likes: '2.8万',
    tag: '老吃瓜人',
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=Fashionable%20young%20Chinese%20person%20portrait%20with%20stylish%20glasses%2C%20modern%20casual%20look%2C%20studio%20portrait%20lighting%2C%20warm%20natural%20expression%2C%20clean%20simple%20background&width=120&height=120&seq=avatar-02&orientation=squarish',
    nickname: '八卦侦探社',
    time: '1小时前',
    content: '那个顶流的瓜我一直在跟，其实上个月就有小道消息了。他那个神秘女友据说是某富商的女儿，两人在海外留学时就认识了，根本不是突然在一起的。',
    likes: '1.6万',
    tag: '资深爆料人',
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=Trendy%20young%20Asian%20female%20portrait%20with%20casual%20denim%20jacket%2C%20confident%20expression%2C%20studio%20lighting%2C%20warm%20golden%20hour%20tones%2C%20clean%20background%2C%20editorial%20style&width=120&height=120&seq=avatar-03&orientation=squarish',
    nickname: '深夜不关机',
    time: '2小时前',
    content: '那个带货翻车的我买过！当时就觉得质地不对，跟专柜完全不一样。找客服还被拉黑了，现在终于有人替我们维权了，已加入维权群等后续！',
    likes: '3.5万',
    tag: '亲历者',
  },
];

export const updateItems = [
  { id: 1, time: '10:42', tag: '突发', content: '某知名男歌手演唱会现场晕倒，已紧急送医，经纪人称系过度劳累所致', isNew: true },
  { id: 2, time: '09:15', tag: '更新', content: '昨日综艺冲突事件后续：节目组发布道歉声明，涉事导演暂停工作接受调查', isNew: true },
  { id: 3, time: '08:30', tag: '爆料', content: '业内人士透露某对荧幕情侣实为合约情侣，私下各有交往对象，合约即将到期', isNew: false },
  { id: 4, time: '07:22', tag: '热点', content: '某女星深夜发文暗示被公司雪藏，粉丝后援会紧急组织线上声援活动', isNew: false },
  { id: 5, time: '昨日 23:45', tag: '追踪', content: '税务风波最新进展：相关部门完成初步调查，涉事金额比此前报道高出三倍', isNew: false },
  { id: 6, time: '昨日 21:30', tag: '独家', content: '某选秀节目冠军被爆学历造假，母校回应称查无此人，学位证书系伪造', isNew: false },
  { id: 7, time: '昨日 19:10', tag: '快讯', content: '热门网剧男主角因片酬纠纷罢演，剧组紧急换角，播出时间或将延期三个月', isNew: false },
];

export const rankingItems = [
  { id: 1, title: '某顶流恋情持续发酵：神秘女友身份终曝光', heat: '2035万', change: 'up', changeNum: '+320万' },
  { id: 2, title: '女主播直播事故后续：品牌方索赔金额曝光', heat: '1892万', change: 'up', changeNum: '+456万' },
  { id: 3, title: '女星税务案新进展：涉案公司法人被带走', heat: '1654万', change: 'up', changeNum: '+189万' },
  { id: 4, title: '综艺冲突导演过往黑历史被扒，劣迹斑斑', heat: '1421万', change: 'up', changeNum: '+567万' },
  { id: 5, title: '饭圈集资乱象调查：未成年粉丝被诱导消费', heat: '1287万', change: 'stable', changeNum: '+45万' },
  { id: 6, title: '男团成员恋爱史全揭秘：时间线完整还原', heat: '1156万', change: 'up', changeNum: '+892万' },
  { id: 7, title: '网红直播带货翻车大盘点：这些品牌要避开', heat: '1023万', change: 'down', changeNum: '-123万' },
];

export const faqItems = [
  {
    id: 1,
    question: '51吃瓜爆料网的爆料内容靠谱吗？',
    answer: '我们的爆料内容均来自多方信源交叉验证，包括业内人士投稿、粉丝投稿以及公开信息整理。每一条爆料发布前都经过编辑团队的核实与评估。当然，娱乐圈信息瞬息万变，我们也会在获得新信息后第一时间更新。建议理性吃瓜，保持独立思考。',
  },
  {
    id: 2,
    question: '如何给51吃瓜爆料网投稿？',
    answer: '我们欢迎广大网友和业内人士投稿！您可以通过页面底部的联系方式，将您掌握的爆料信息发送给我们。投稿请尽可能提供详细的时间、地点、人物和证据材料（如照片、视频、聊天记录等）。我们会严格保护投稿人的隐私信息，绝不泄露来源。',
  },
  {
    id: 3,
    question: '每日爆料汇总多久更新一次？',
    answer: '我们实行7×24小时全天候更新机制。编辑团队覆盖早班、晚班和夜班三个班次，确保全网最新吃瓜资讯第一时间呈现。每日爆料汇总固定在每天凌晨6点、中午12点、下午6点和晚上10点四个时段进行集中更新。遇到重大突发事件，我们会即时推送。',
  },
  {
    id: 4,
    question: '51吃瓜爆料网和51吃瓜官网是什么关系？',
    answer: '51吃瓜爆料网是51吃瓜旗下的内容平台之一，专注于娱乐圈八卦、网红黑料和每日爆料汇总。51吃瓜官网（51chigua.com）是品牌主站，提供完整的吃瓜生态服务，包括社区讨论、爆料投稿、话题投票等功能。两者内容互通，但定位各有侧重。',
  },
  {
    id: 5,
    question: '如何第一时间获取最新爆料？',
    answer: '推荐您使用以下几种方式：1）将本站加入浏览器收藏夹，每天定时访问；2）关注我们的社交媒体账号（微博、微信公众号搜索"51吃瓜爆料"）；3）下载51吃瓜APP，开启推送通知，重大爆料第一时间送达。目前APP支持iOS和Android双平台。',
  },
  {
    id: 6,
    question: '爆料内容涉及侵权怎么办？',
    answer: '我们严格遵守法律法规，尊重每个人的合法权益。如果您认为本站发布的某条内容侵犯了您的名誉权、隐私权或肖像权，请通过页面底部的联系方式与我们取得联系，提供相关证明材料。我们在核实后会按照法律规定及时处理，包括但不限于修改、删除或澄清相关内容。',
  },
];

export const mediaItems = [
  {
    id: 1,
    title: '独家对话：揭秘娱乐圈爆料产业链运作内幕',
    duration: '15:28',
    views: '89.7万',
    image: 'https://readdy.ai/api/search-image?query=Professional%20interview%20setup%20with%20two%20people%20in%20modern%20studio%2C%20soft%20warm%20lighting%2C%20podcast%20recording%20atmosphere%2C%20microphones%20and%20headphones%2C%20content%20creation%20aesthetic&width=800&height=500&seq=media-01&orientation=landscape',
    tag: '深度访谈',
  },
  {
    id: 2,
    title: '2026上半年娱乐圈十大翻车事件完整回顾',
    duration: '22:45',
    views: '156.3万',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20video%20editing%20suite%20with%20timeline%20screens%20showing%20entertainment%20news%20montage%2C%20dark%20room%20with%20warm%20monitor%20glow%2C%20professional%20editing%20workstation%2C%20media%20production%20atmosphere&width=800&height=500&seq=media-02&orientation=landscape',
    tag: '年度盘点',
  },
  {
    id: 3,
    title: '网红孵化工厂探秘：一天生产100个网红的流水线',
    duration: '18:52',
    views: '67.4万',
    image: 'https://readdy.ai/api/search-image?query=Modern%20content%20creation%20studio%20with%20multiple%20streaming%20setups%20and%20ring%20lights%2C%20busy%20creative%20workspace%2C%20behind%20scenes%20production%2C%20warm%20studio%20lighting%2C%20professional%20video%20equipment&width=800&height=500&seq=media-03&orientation=landscape',
    tag: '行业揭秘',
  },
];

export const featureItems = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '全网最快爆料',
    description: '7×24小时全天候监控全网动态，重大爆料事件5分钟内上线，做你吃瓜的第一站',
  },
  {
    id: 2,
    icon: 'ri-shield-check-line',
    title: '多方信源验证',
    description: '每条爆料均经过编辑团队多方交叉验证，拒绝谣言和虚假信息，做靠谱的吃瓜平台',
  },
  {
    id: 3,
    icon: 'ri-group-line',
    title: '千万吃瓜群众',
    description: '日均活跃用户超千万，评论区讨论热烈，一起理性吃瓜分享八卦的快乐',
  },
  {
    id: 4,
    icon: 'ri-smartphone-line',
    title: '移动端随时看',
    description: '支持iOS和Android双平台APP，推送通知即时到达，掏出手机就能掌握最新爆料',
  },
  {
    id: 5,
    icon: 'ri-lock-line',
    title: '投稿隐私保护',
    description: '严格保护爆料人隐私信息，采用多重加密技术，确保投稿来源绝不外泄',
  },
];

export const indexItems = [
  { id: 1, title: '明星恋情合集', count: '326篇', icon: 'ri-heart-line', color: 'accent' },
  { id: 2, title: '网红翻车实录', count: '218篇', icon: 'ri-error-warning-line', color: 'primary' },
  { id: 3, title: '综艺内幕揭秘', count: '187篇', icon: 'ri-tv-line', color: 'secondary' },
  { id: 4, title: '明星税务风波', count: '95篇', icon: 'ri-money-cny-circle-line', color: 'primary' },
  { id: 5, title: '直播带货打假', count: '162篇', icon: 'ri-shopping-bag-line', color: 'accent' },
  { id: 6, title: '娱乐圈潜规则', count: '143篇', icon: 'ri-eye-off-line', color: 'secondary' },
  { id: 7, title: '每日爆料汇总', count: '1,208篇', icon: 'ri-file-list-3-line', color: 'primary' },
];

export const navItems = [
  { id: 'ranking', label: '热度榜单', href: '#ranking' },
  { id: 'updates', label: '最新快讯', href: '#updates' },
  { id: 'media', label: '视频爆料', href: '#media' },
  { id: 'faq', label: '常见问答', href: '#faq' },
  { id: 'about', label: '关于我们', href: '#about' },
];